import { Button } from "antd";
import { useExportExcel } from "../../../../lib/hooks/exportExcel";
import ImpoundsService from "../../../../services/accounts/impounds";

export const ImpoundBalances = () => {
  const { onExportExcelButtonClicked, isLoading } = useExportExcel(
    ImpoundsService,
    {},
    "impound-balances.xlsx"
  );

  return (
    <Button
      className="pa-0"
      type="link"
      size="small"
      onClick={onExportExcelButtonClicked}
      disabled={isLoading}
    >
      Impound Balances
    </Button>
  );
};
